<template>
  <!-- Fondo -->
  <transition name="fade">
    <div v-if="visible"
      class="fixed inset-0    bg-black/30  flex items-center justify-center z-50">

      <!-- Modal -->
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6   transform transition-all scale-100 border border-gray-200">
        <div class="flex justify-between">
            <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;ModalSolicitud&#62;</span>
        </div>
        <!-- Header -->
        <div class="relative border-b pb-4 mb-6 flex items-center justify-center">
 <!-- Título sección -->
 
 
          <!-- Título centrado -->
          <h2 class="text-xl font-semibold text-gray-800 text-center w-full">
           Solicitud  presupuesto  año {{ this.$store.state.auth.userLogin.año_borrador }} 
          </h2>

          <!-- Botón cerrar -->
          <button @click="cerrar"
            class="absolute right-0 text-gray-400 hover:text-gray-600 transition text-2xl leading-none">
            ✕
          </button>
        </div>

        <!-- Subtítulo: centro y cuenta -->
        <div class="mb-4">
          <div class="text-base font-medium text-gray-700">
            {{ datos.nomcentro }}
            <span class="text-gray-400 mx-1">/</span>
            {{ datos.nomcta }}
          </div>
        </div>

        <!-- Contenedor interno -->
        <div class="bg-gray-50 p-5 rounded-xl border border-gray-200 space-y-5">

           <!-- Input monto -->
          <div>
            <label class="block text-sm text-gray-700 font-medium mb-1">
              Descripcion
            </label>

            <input type="text" placeholder="descripcion aqui" 
              @blur="handleBlurMonto" 
              v-model="descripcion_solicitud"
              class="border rounded-lg px-4 py-3 w-full bg-white shadow-sm text-base 
               text-gray-800 focus:ring-2 focus:ring-blue-300 outline-none transition" :class="{
                'border-gray-300': !error_descripcion,
                'border-red-500': error_descripcion
              }" />

            <!-- Errores -->
            <p v-if="error_descripcion" class="text-red-500 text-xs mt-1 flex items-center gap-2">
              ❌ Debe ingresar una descripcion.
            </p>

          </div>
 
       
 
          <!-- Input monto 
          <div>
            <label class="block text-sm text-gray-700 font-medium mb-1">
              Monto
            </label>

            <input type="text" placeholder="Ingrese el monto" @blur="handleBlurMonto" 
              v-model="monto_solicitud"
              class="border rounded-lg px-4 py-3 w-full bg-white shadow-sm text-base 
               text-gray-800 focus:ring-2 focus:ring-blue-300 outline-none transition" :class="{
                'border-gray-300': !error_monto,
                'border-red-500': error_monto
              }" />

            
            <p v-if="error_monto" class="text-red-500 text-xs mt-1 flex items-center gap-2">
              ❌ Debe ingresar un monto.
            </p>

            <p v-if="error_monto_invalido" class="text-red-500 text-xs mt-1 flex items-center gap-2">
              ❌ Monto no válido.
            </p>
          </div>
 -->
          <!-- Botón confirmar -->
          <button @click="confirmar()" class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold 
             py-3 rounded-lg shadow transition text-base">
            Confirmar
          </button>
        </div>

        <!-- Footer -->
        <div class="flex justify-end mt-8 pt-4 border-t">
          <button @click="cerrar" class="px-5 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 
             text-gray-700 font-medium transition">
            Cerrar
          </button>
        </div>

        <!-- Debug si lo necesitas -->
        <!-- {{ datos }} -->

      </div>

    </div>
  </transition>
</template>


<script>

export default {
  name: "ModalIngresoMes",
  emits: ['get_monto_mensual_presupuesto', 'get_solicitud'],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },


    datos: {
      type: Object
    },

  },
  computed: {

  },
  watch: {
    visible: function (v) {
      console.log('visible', v);
      if (v) {
    
        this.monto_solicitud = '';
        this.descripcion = '';
        this.signo_operacion = '';
        this.total_tentativo = 0;
        this.descripcion_solicitud='';
      }
    },
    datos: function (v) {



      this.nommes = v.nommes;
      this.nomcentro = v.nomcentro;
      this.nomcta = v.nomcta
      this.total_presup_anio_anterior = v.total_presup_anio_anterior


    },
    opcionSeleccionada: function (v) {

      if (!v) return;
      this.recalcular()

    },
    monto_solicitud: function (v) {
      this.monto_solicitud = (!isNaN(v) && v) || '';
    
    }

  },
  methods: {
    cerrar() {
      this.$emit("update:visible", false);
    },



    confirmar() 
    {
      const monto_solicitud = parseFloat(this.monto_solicitud);
      const descripcion_solicitud = this.descripcion_solicitud;
      if (!descripcion_solicitud) {
        this.error_solicitud = true;
        return false;
      }
      //if (!monto_solicitud) {
      //  this.error_monto = true;
      //  return false;
      //}
      console.log(descripcion_solicitud, monto_solicitud )
      this.$emit("get_solicitud", {  
                  'descripcion_solicitud': descripcion_solicitud,
                  'monto_solicitud': monto_solicitud });
      this.cerrar();
      this.monto_solicitud = ''
      return true;
    },
     
  },
  data() {
    return {
      total_presup_anio_anterior: 0,
      glosa: '',
      rendicion_id: 0,

      mes: 0,
      nomcentro: '',
      nomcta: '',
      nommes: ' ',

      monto_solicitud: '',
      descripcion_solicitud:'',
      error_monto: '',
      error_monto_invalido: '',
      error_descripcion : '',
      opcionSeleccionada: '',
      signo_operacion: '',
      total_tentativo: 0
    }
  },
  mounted() {
    console.log('montar')
    this.monto_solicitud = ''
    this.descripcion_solicitud = ''
  }
};
</script>

<style scoped></style>
